var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2WindDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-8H30v-4h18v-8l10.78 10L48 67zm7-39.44L21 35.5V66h-4V7.46L55 18v9.56zM26 14.1l-5-1.38v18.67l5-1.17V14.1zm12 3.33l-6-1.66v13l6-1.4v-9.94zM51 21l-7-1.9V26l7-1.64V21z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Wind_direction.09c42d33.svg";
export { SvgB2WindDirection as ReactComponent };